
import { npuEventStatistics, getCourseTypeInfo } from '../utils/npuTracker'
//公用图片
Vue.component("collect_and_like", {
  props: {
    collect_param: {
      type: Object,
      default: {}
    },
    like_param: {
      type: Object,
      default: {}
    },
    has_login: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      collectionCount: 0,
      likeCount: 0,
      isCollect: false,
      isLike: false,
    }
  },
  mounted() {
    this.getCollectionCount()
    this.getLikeCount()
  },
  methods: {//收藏
    collectHandle() {
      if(!this.has_login) return
      API.reqCourseCollect(this.collect_param).then(res => {
          if (res.status === 200) {
            this.$message.success({ message: '收藏成功', duration: 1000 });
          }
          this.getCollectionCount()
          this.npuCollectStatistics({code: 'collect_course', success: res.status === 200})
        })
    },
    //取消收藏
    unCollectHandle() {
      if(!this.has_login) return
      API.reqCourseUncollect({ courseId: this.collect_param.courseId }).then(res => {
        this.isCollect = false
        this.getCollectionCount()
        this.npuCollectStatistics({code: 'notCollect_course', success: res.status === 200})
      })
    },
    npuCollectStatistics(option){
      const {code, success} = option
      const {courseTypeName, courseTypeCode} = getCourseTypeInfo()
      //西工大统计-收藏、取消收藏课程
      npuEventStatistics({
        eventCode: code,
        eventOpeartionObjectCatelogName: courseTypeName,
        eventOpeartionObjectCatelogCode: courseTypeCode,
        eventOpeartionObjectName: this.collect_param.courseName,
        eventOpeartionObjectCode: this.collect_param.courseId,
        eventOpeartionObjectDetail: (code == 'collect_course'?'收藏':'取消收藏') + this.collect_param.courseName,
        eventOpeartionResult: success?'成功':'失败'
      })
    },
    //获取收藏数量
    getCollectionCount() {
      API.reqCourseCollectMe({ courseId: this.collect_param.courseId }).then(res => {
        if (res.message === config.successMessage) {
          this.collectionCount = typeof res.data === 'number' ? res.data : res.data.collectionSize;
          this.isCollect = typeof res.data === 'number' ? false : res.data.isCollection;
        }
      })
    },
    //获取点赞数量和状态
    getLikeCount() {
      API.reqCourseLikeNumber({ courseId: this.like_param.courseId }).then(res => {
        if (res.status == 200) {
          this.likeCount = res.data || 0
        }
      })
      API.reqCourseLikeStatus({ courseId: this.like_param.courseId }).then(res => {
        if (res.status == 200) {
          this.isLike = res.data
        }
      })
    },
    //取消点赞
    unLikeHandle() {
      if(!this.has_login) return
      API.reqCourseLikeCalcel({ courseId: this.like_param.courseId }).then(res => {
        if (res.status == 200) {
          this.isLike = false
        }
        this.getLikeCount()
      })
    },
    //课程点赞
    likeHandle() {
      if(!this.has_login) return
      API.reqCourseLikeAdd(this.like_param).then(res => {
          if (res.status === 200) {
            this.isLike = true
            this.$message.success({ message: '点赞成功', duration: 1000 });
          }
          this.getLikeCount()
        })
    },
    //数字格式化，超过1000显示几k或几w
    numberFormate(num){
        num = isNaN(Number(num))?0:Number(num)
        if(num < 1000){
            return num
        } else if(num < 10000){
            return parseInt(num / 1000) + 'k+'
        } else {
            return parseInt(num / 10000) + 'w+'
        }
    }
  },
  template: `
  <span class="collect_and_like">
    <el-tooltip v-if="like_param.courseId" :content="$t('登录后可点赞')" :disabled="has_login" placement="top">
      <span v-if="isLike" class="bar_btn active" @click="unLikeHandle">
        <iconfont type="iconyizan" class="bar_btn_icon collect"></iconfont>
        <span>{{numberFormate(likeCount)}} {{$t('点赞')}}</span>
      </span>
      <span v-else @click="likeHandle" class="bar_btn">
        <iconfont type="icondianzan" class="bar_btn_icon uncollect"></iconfont>
        <span>{{numberFormate(likeCount)}} {{$t('点赞')}}</span>
      </span>
    </el-tooltip>
    <el-tooltip v-if="collect_param.courseId" :content="$t('登录后可收藏')" :disabled="has_login" placement="top">
      <span v-if="isCollect" class="bar_btn active" @click="unCollectHandle">
        <iconfont type="icona-shoucangbeifen2" class="bar_btn_icon collect"></iconfont>
        <span>{{numberFormate(collectionCount)}} {{$t('收藏')}}</span>
      </span>
      <span v-else @click="collectHandle" class="bar_btn">
        <iconfont type="iconcollect" class="bar_btn_icon uncollect"></iconfont>
        <span>{{numberFormate(collectionCount)}} {{$t('收藏')}}</span>
      </span>
    </el-tooltip>
  </span>`
});